import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const TrialBalancePage = () => {
    const navigate = useNavigate(); // Use useNavigate hook for navigation

   function getActionsForPage(pageName) {
     const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1');
      return [];
    }
  }

  const pageName = 'TrialBalancePage';
  const actionsForPage = getActionsForPage(pageName);


  const [data, setData] = useState({ trial_balance: [], total_debit: 0, total_credit: 0 });
const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
 const fetchTrialBalance = async () => {
    try {
      const res = await axios.get("https://subk.education.com.ly/back/api/reports/trial-balance", {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
      });
      setData(res.data);
    } catch (err) {
      console.error(err);
    }
  };
   useEffect(() => {
    fetchTrialBalance();
  }, []); // initial load

  const handleFilter = (e) => {
    e.preventDefault();
    fetchTrialBalance();
  };

  return (
    <div className="container mt-4" dir="rtl">
      <h2 className="mb-4">ميزان المراجعة</h2>
        <form className="row g-3 mb-4" onSubmit={handleFilter}>
        <div className="col-md-3">
          <label>من تاريخ:</label>
          <input
            type="date"
            className="form-control"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <label>إلى تاريخ:</label>
          <input
            type="date"
            className="form-control"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        <div className="col-md-3 align-self-end">
          <button type="submit" className="btn btn-primary">تصفية</button>
        </div>
      </form>
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>الحساب</th>
            <th>النوع</th>
            <th>مدين</th>
            <th>دائن</th>
          </tr>
        </thead>
        <tbody>
          {data.trial_balance.map((line, idx) => (
            <tr key={idx}>
              <td>{line.AccountName}</td>
              <td>{line.AccountType}</td>
              <td>{line.Debit}</td>
              <td>{line.Credit}</td>
            </tr>
          ))}
          <tr className="table-secondary">
            <td colSpan="2"><strong>الإجمالي</strong></td>
            <td><strong>{data.total_debit}</strong></td>
            <td><strong>{data.total_credit}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TrialBalancePage;
